<template>
<b-container
  class="py-5 d-flex section"
  style="background-color: #08034c;"
  fluid
>
  <b-row class="justify-content-center align-self-center mx-auto">
    <b-col>
      <iframe 
        :title="title" 
        :src="src" 
        :width="videoWidth" 
        :height="videoHeight" 
        frameborder="0" 
        allowfullscreen
      ></iframe>
      <!--p class="text-light text-center">{{ videoWidth }}x{{ videoHeight }}</p-->
    </b-col>
  </b-row>
</b-container>
</template>

<script>
import { vueWindowSizeMixin } from "vue-window-size";
export default {
  name: "VideoSection",
  props: {
    title: String,
    src: String
  },
  mixins: [vueWindowSizeMixin],
  computed: {
    md () {
      this.windowWidth >= 575 && this.windowWidth < 767;
    },
    lg () {
      this.windowWidth >= 768;
    },
    videoWidth () {
      if (this.windowWidth >= 768) {
        return 640;
      } else if (this.windowWidth >= 575 && this.windowWidth < 767) {
        return 480;
      } else if (this.windowWidth < 575) {
        return 320;
      }
    },
    videoHeight () {
      if (this.windowWidth >= 768) {
        return 360;
      } else if (this.windowWidth >= 575 && this.windowWidth < 767) {
        return 270;
      } else if (this.windowWidth < 575) {
        return 180;
      }
    }
  }
}
</script>